export const LG_DRAWER_OPEN_WIDTH = 288;
export const LG_DRAWER_CLOSED_WIDTH = 110;
